var quizServiceErrorIds = Object.freeze({
   badDefinition: 'bad_quiz_definition'
});

export {quizServiceErrorIds};
